export default __webpack_public_path__ + "static/media/bookmark-dash.3f96262d.svg";